<template>
  <v-card max-width="800" class="mx-auto" flat>
    <v-container>
      <v-item-group v-model="selected" mandatory>
        <v-row>
          <v-col v-for="(item, i) in items" :key="i" cols="12">
            <v-item v-slot="{ active, toggle }">
              <v-card class="mx-auto" max-width="500" :elevation="active ? 4 : 2" @click="toggle">
                <v-img
                  class="white--text"
                  :height="active ? `145` : '85'"
                  :src="item.src"
                  @click="updateImpactTypeId(item)"
                  gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
                  :style="active ? `border: 4px solid ${color};` : 'filter: grayscale(100%);'"
                >
                  <v-card-title>{{ $t(item.title, { company: company }) }}</v-card-title>
                  <v-card-subtitle v-if="active" class="pb-0">
                    {{ $t(item.subtitle) }}
                  </v-card-subtitle>
                  <v-card-actions v-if="active">
                    <v-btn icon dark>
                      <v-icon color="white">mdi-heart</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-img>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <bad-conscience-dialog ref="badConscienceDialog" :impactTypeItem="item" />
    </v-container>
  </v-card>
</template>
<script lang="ts">
import BadConscienceDialog from "@/components/thg/BadConscienceDialog.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Ref, Vue } from "vue-property-decorator";
import { IThgImpact } from "./interface/ThgImpact.interface";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: {
    BadConscienceDialog
  }
})
export default class ThgImpactSelectorCard extends Vue {
  @Ref("badConscienceDialog")
  readonly badConscienceDialog!: BadConscienceDialog;

  get selected() {
    return ThgCreateModule.impactTypeId;
  }

  set selected(id) {
    ThgCreateModule.setImpactTypeId(id);
  }

  get company() {
    return ReportModule.partner.companyName;
  }

  get items() {
    return ThgCreateModule.activeImpactTypeItems;
  }

  get item() {
    return ThgCreateModule.impactTypeItem;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  updateImpactTypeId(item: IThgImpact) {
    ThgCreateModule.setImpactType(item.impactType);
    ThgCreateModule.setImpactFactor(item.baseImpactFactor);

    if (item.showDialog) {
      this.badConscienceDialog.openDialog();
    }
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
